var map = {
	"./ai-education-classroom.jpg": 6832,
	"./cbseOffice.jpeg": 4027,
	"./formative-assessment-digital.jpg": 7454,
	"./future-education-ai.jpeg": 9839,
	"./future-education-ai.jpg": 1010,
	"./priya.jpeg": 949,
	"./teacher-grading-ai.jpeg": 7186,
	"./teacher-grading-ai.jpg": 733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6385;